<div class="vtz-main-wrapper">
  <div class="vtz-main-container vtz-main-container--ballot">
    <div class="vtz-title-section vtz-title-section--blue">
      <app-header></app-header>
    </div>
    <main>
      <app-progress-bar [routeName]="routeName"></app-progress-bar>
      @if(aboutService.idUploadFlow) {
        <h1 class="vtz-h1" id="main-title"  i18n>Dashboard</h1>
        <app-dashboard></app-dashboard>
      } @else {
        <h1 class="vtz-h1" id="main-title"  i18n>Ballots</h1>
        <p class="vtz-text vtz-text--wide vtz-text--center" i18n>
          Below is a list of your unvoted ballots. Select a ballot to begin making selections.
    		</p>
              
        <div class="vtz-questions__list">
          <div class="vtz-questions__list-item">
            <fieldset>
              <div role="radiogroup"
                [attr.aria-labelledby]="'main-title ballots-legend'">
                <legend id="ballots-legend" class="vtz-text--small">Select one of {{ballotsCount}} ballots </legend>

                @for (ballot of ballots; track ballot; let i = $index) {
                  <label class="vtz-form__radio-container vtz-text"
                    [ngClass]="{'vtz-form__radio-container--selected': checkedIndex === i ,  
                    'focused': focusStates[i]} "
                    >
                    <span class="tz-text vtz-text--ballot " style="white-space: pre-line "
                      i18n>
                      {{ballot.voteEventData.description}} <br>
                      @if (ballot.voteEventData.description1) {
                        {{ ballot.voteEventData.description1 }} <br>
                      }
                      @if (ballot.voteEventData.description2) {
                        {{ballot.voteEventData.description2}} <br>
                      }         
                    </span>
                    <input #row type="radio"
                      name="ballots"
                      value="{{i}}"
                      (change)="selectAnswer(i)"
                      (focus)="onFocus(i)"
                      (blur)="onBlur(i)" />
                      <span class="vtz-form__radio-checkmark"></span>
                  </label>
                }
              </div>
            </fieldset>
            <div class="vtz-actions">
              <button [disabled]="checkedIndex === undefined"
                id="ballots-next" class="button-primary"
                (click)="next()"
              i18n>Start</button>
            </div>
          </div>
        </div>
      }
    </main>
  </div>
</div>
<app-back-button-confirmation-modal>
</app-back-button-confirmation-modal>
